import api from './api';

export const closeoutApi = {
  getAll: () => api.get('/api/closeouts'),
  getLatest: () => api.get('/api/closeouts/latest'),
  getPreviewToday: () => api.get('/api/closeouts/preview/today'),
  getById: (id) => api.get(`/api/closeouts/${id}`),
  create: (data) => api.post('/api/closeouts/create', data),
};
